
/**
 * @fileOverview LazyImages module definition
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;
    
    define('polyfills/lazyLoadImages',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function (require) {       
        var $ = require('jquery'),
            util = require('lib/Util'),
            GlobalEventDispatcher = require('GlobalEventDispatcher'),
            GlobalResizeListener = require('GlobalResizeListener');            

        $debug('jsLazyImages loaded - use ?debug=jsLazyImages for messages');
        require(['domReady!'], function (doc) {
            $debug('**** Lazy Images Started **** ', 'jsLazyImages'); //syntax: $debug(message, urlParam);            
            $('.js-lazy').each(function (i,element) {
                $debug('Found Lazy Image Element #' + (i + 1), 'jsLazyImages');
                new LazyImages($(element));
            });
        });
         
        /**
         * This sets up scrollorama effects.
         *
         * @class LazyImages
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var LazyImages = function ($element) {            
            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             */

            this.$element = $element;   //store element as property of main object

            /**
             * A reference to the global event dispatcher, provided by the application.
             *
             * @property eventDispatcher
             * @type {}
             * @private
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application

            /**
             * A reference to the global resize listener.
             *
             * @property getResizeListener
             * @type {}
             * @private
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();            

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @name isEnabled
             * @type bool
             */
            this.isEnabled = false;

            this.init(); //initialize component
        };

        /**
         * Initializes the UI Component View
         * Runs setOptions method, followed by enable/build method - chain additional ones if needed
         *
         * @method init
         * @returns {LazyImages}
         * @private
         */
        LazyImages.prototype.init = function () {
            this
                .setOptions()
                .setupHandlers()
                .layout();

            return this;
        };

        /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         * Syntax for HTML should be data-options='{"exampleOption" : "bar", "enabled" : false, "xLength" : 45, "option2" : "foo"}'
         *
         * @method setOptions
         * @returns {LazyImages}
         * @private
         */
        LazyImages.prototype.setOptions = function () {
            var options = this.$element.data().options;
            var defaults = {
                mobile : null,
                tablet : null,
                desktop : null,
                luxury : null
            };

            this.settings = $.extend({}, defaults, options);    //merge defaults with data-options object
            $debug('     LazyImages Options ', 'jsLazyImages');
            $debug('          HTML data-options Settings: ' + $printObj(options),'jsLazyImages');
            $debug('          Default Settings: ' + $printObj(defaults),'jsLazyImages');
            $debug('          Combined Settings: ' + $printObj(this.settings),'jsLazyImages');
            return this;
        };

        /**
         * This sets the event handlers for the module
         *
         * @method setOptions
         * @returns {LazyImages}
         * @private
         */
        LazyImages.prototype.setupHandlers = function () {
            $debug('set up handlers', 'jsLazyImages');
            // Bind event handlers scope here
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.layout.bind(this));

            return this;
        };

        /**
         * Builds the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {LazyImages}
         * @public
         */

        LazyImages.prototype.layout = function () {
            $debug('layout changed', 'jsLazyImages');
            var self = this;
            var context = this.globalResizeListener.getCurrentContext();
            var newSrc;
                switch (true) {
                case context === 'luxuryContext':
                    //luxury
                    $debug('...luxury', 'jsLazyImages');
                    newSrc = self.settings.luxury;
                    break;
                case context === 'largeContext':
                    //desktop
                    $debug('...desktop', 'jsLazyImages');
                    newSrc = self.settings.desktop;
                    break;
                case context === 'mediumContext':
                    //tablet
                    $debug('...tablet', 'jsLazyImages');
                    newSrc = self.settings.tablet;
                    break;
                case context === 'smallContext':
                    //mobile
                    $debug('...mobile', 'jsLazyImages');
                    newSrc = self.settings.mobile;
                    break;
                default:
                    //error flow                   
                    break;
                }
            $debug('Setting image to ' + newSrc, 'jsLazyImages');
            self.$element.attr('src', newSrc);

            return this;
        };


    }); //end define

}(MMMRequire));